import { matchPath, useLocation } from 'react-router';
import {
  USER_PROFILE_INVESTMENTS_ROUTE,
  USER_PROFILE_ROUTE,
  USER_PROFILE_LIBRARY_ROUTE,
  USER_PROFILE_INVESTOR_ROUTE,
} from 'client/constants/routes';
import { useAppSelector } from 'client/hooks';
import { selectUser } from 'client/redux/user/selectors';
import { selectUI } from 'client/redux/ui/selectors';

export const useUnblockLevelBannerVisibility = () => {
  const location = useLocation();
  const user = useAppSelector(selectUser);
  const { bannerUnlockLevel } = useAppSelector(selectUI);
  const isOnProfilePage = [
    USER_PROFILE_INVESTMENTS_ROUTE,
    USER_PROFILE_ROUTE,
    USER_PROFILE_LIBRARY_ROUTE,
    USER_PROFILE_INVESTOR_ROUTE,
  ].some((route) => Boolean(matchPath(location.pathname, { path: route, exact: true })));
  const isLevelOneInvestor = user.role === 'INVESTOR_LEVEL_1' && user.status === 'NONE';

  return !isOnProfilePage && isLevelOneInvestor && bannerUnlockLevel === 'visible';
};
